import { render, staticRenderFns } from "./sliderCategorias.vue?vue&type=template&id=c6f5710a&scoped=true&"
import script from "./sliderCategorias.vue?vue&type=script&lang=js&"
export * from "./sliderCategorias.vue?vue&type=script&lang=js&"
import style0 from "./sliderCategorias.vue?vue&type=style&index=0&id=c6f5710a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f5710a",
  null
  
)

export default component.exports